import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Go Live (/go-live → SettingsDomainPage entryPoint="go-live"). */
export function getGoLiveTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Go live',
        description:
          'This is where you publish your site to the web and manage the address people use to ' +
          'find it.',
      },
    },
    {
      element: at('golive-target'),
      popover: {
        title: 'Your live address',
        description: 'The web address where your site is being served to the public right now.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('golive-fallback'),
      popover: {
        title: 'Your free address',
        description:
          'Every site gets a free address (yourname.searchproperties.io). It always works — even ' +
          'if you later connect your own custom domain.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('golive-deployment'),
      popover: {
        title: 'Site status',
        description:
          'Shows whether your site is live or still needs publishing. To use your own domain, add ' +
          'it from the Domains section.',
        side: 'bottom',
        align: 'start',
      },
    },
  ];
}
